<!-- Sidebar -->
@if(isAuthenticated()) {
  <div id="sidebar-wrapper" class="d-print-none">
    <aside
      #leftNavPanel
      class="left-nav-panel ms-2"
      [class.is-collapsed]="isMainMenuMinimized()"
      (mouseleave)="onPanelMouseLeave()">
      @if(!isProduction) {
        <button
          type="button"
          class="left-nav-environment-badge no-select"
          [pTooltip]="reloadForMfStyles() ? 'Klicka för att byta till mf-stylesheet' : ''"
          [disabled]="!reloadForMfStyles()"
          (click)="addMfDomainParam()">
          <p-badge
            [value]="environmentBadgeLabel"
            severity="warn"
            class="left-nav-environment-badge-value">
          </p-badge>
        </button>
      }

      <div class="left-nav-header mb-2">
        @let img = !isMf() ? 'assets/images/Svf_Circle_neg.svg' : 'assets/images/Mockfjards_logo_CMYK_ikon_offwhite_CMYK.svg';
        <a [routerLink]="[isAftermarket() ? '/aftermarketIssues' : '/start']"><img class="left-nav-logo" [src]="img" [alt]="isMf() ? 'Mockfjärds' : 'Svenska Fönster'" title="Kundportalen" /></a>
      </div>

      <div class="left-nav-scroll">
        <nav class="left-nav-menu" aria-label="Sidomeny">
          <ul class="left-nav-list">
            @for(item of sideMenuItems(); track item.id ?? $index) {
              @if(item.separator) {
                <li class="left-nav-separator mt-2 mb-3" aria-hidden="true"></li>
              } @else {

                <li
                  class="left-nav-item"
                  [attr.data-menu-id]="item.id"
                  [class.has-children]="hasChildren(item)"
                  [class.is-active]="isItemActive(item)"
                  [class.is-inline-open]="isInlineExpanded(item)">

                  <button type="button" class="left-nav-trigger" [class.is-active]="isItemActive(item)" [attr.title]="item.title ?? item.label" (click)="onItemTrigger(item, $event)" (mouseenter)="onItemMouseEnter(item, $event)">
                    <span class="left-nav-icon-wrap">
                      <i class="left-nav-icon" [class]="item.icon"></i>
                      @if(item.badge) {
                        <span class="left-nav-badge">{{ item.badge }}</span>
                      }
                    </span>

                    @if(!isMainMenuMinimized()) {
                      <span class="left-nav-label">{{ item.label }}</span>
                    }

                    @if(hasChildren(item)) {
                      @if(isMainMenuMinimized() || !isInlineExpanded(item)) {
                        <i class="left-nav-caret fa-duotone fa-angle-right"></i>
                      } @else {
                        <i class="left-nav-caret fa-duotone fa-angle-down"></i>
                      }
                    }
                  </button>

                  @if(!isMainMenuMinimized() && hasChildren(item) && isInlineExpanded(item)) {
                    <ul class="left-nav-inline-submenu">
                      @for(child of item.children ?? []; track child.id ?? $index) {
                        <li class="left-nav-subitem">
                          @if(child.type === 'toggle') {
                            <div class="left-nav-subtoggle">
                              <check-box
                                [title]="child.label ?? ''"
                                [elementId]="child.elementId ?? null"
                                [value]="!!child.checked"
                                [justifyContent]="'justify-content-between'"
                                [order]="'title-first'"
                                (onSwitch)="onToggleItem(child, $event)">
                              </check-box>
                            </div>
                          } @else {
                            <button
                              type="button"
                              class="left-nav-subtrigger"
                              [class.is-active]="isItemActive(child)"
                              [attr.title]="child.title ?? child.label"
                              (click)="onItemTrigger(child, $event)">
                              <i class="left-nav-subicon" [class]="child.icon"></i>
                              <span class="left-nav-sublabel">{{ child.label }}</span>
                              @if(child.badge) {
                                <span class="left-nav-subbadge">{{ child.badge }}</span>
                              }
                            </button>
                          }
                        </li>
                      }
                    </ul>
                  }
                </li>
              }
            }
          </ul>
        </nav>
      </div>

      <div class="left-nav-footer">
        <div class="left-nav-separator left-nav-footer-separator" aria-hidden="true"></div>
        <button
          type="button"
          class="left-nav-account-trigger"
          [class.is-open]="isAccountMenuOpen()"
          [attr.title]="userFullName() || 'Min profil'"
          (click)="toggleAccountMenu($event)"
          (mouseenter)="cancelAccountMenuClose()"
          (mouseleave)="scheduleAccountMenuClose()">
          @if(selectedUser()) {
            <p-overlaybadge severity="warn" [title]="selectedUser()?.USERFULLNAME || selectedUser().USERNAME">
              <kp-initials></kp-initials>
            </p-overlaybadge>
          } @else {
            <kp-initials></kp-initials>
          }
        </button>
        <button
          type="button"
          class="left-nav-logout-trigger"
          title="Logga ut"
          (click)="logout()">
          <i class="fa-regular fa-arrow-right-from-bracket"></i>
        </button>
      </div>

      @if(isMainMenuMinimized() && activeFlyoutItem(); as flyoutItem) {
        <div
          class="left-nav-flyout"
          [style.top.px]="flyoutTop()"
          (mouseenter)="cancelFlyoutClose()"
          (mouseleave)="scheduleFlyoutClose()">
          <div class="left-nav-flyout-title">{{ flyoutItem.label }}</div>
          <ul class="left-nav-flyout-list">
            @for(child of flyoutItem.children ?? []; track child.id ?? $index) {
              <li class="left-nav-flyout-item">
                @if(child.type === 'toggle') {
                  <div class="left-nav-flyout-toggle">
                    <check-box
                      [title]="child.label ?? ''"
                      [elementId]="child.elementId ?? null"
                      [value]="!!child.checked"
                      [justifyContent]="'justify-content-between'"
                      [order]="'title-first'"
                      (onSwitch)="onToggleItem(child, $event)">
                    </check-box>
                  </div>
                } @else {
                  <button
                    type="button"
                    class="left-nav-flyout-trigger"
                    [class.is-active]="isItemActive(child)"
                    [attr.title]="child.title ?? child.label"
                    (click)="onFlyoutItemClick(child, $event)">
                    @if(child.icon) {
                      <i class="left-nav-flyout-icon" [class]="child.icon"></i>
                    }
                    <span class="left-nav-flyout-label text-md">{{ child.label }}</span>
                    @if(child.badge) {
                      <span class="left-nav-subbadge">{{ child.badge }}</span>
                    }
                  </button>
                }
              </li>
            }
          </ul>
        </div>
      }

      @if(isAccountMenuOpen()) {
        <div
          class="left-nav-account-menu" (mouseenter)="cancelAccountMenuClose()" (mouseleave)="scheduleAccountMenuClose()">
          @if(userFullName()) {
            <div class="left-nav-account-heading">{{ userFullName() }}</div>
          }

          <button type="button" class="left-nav-account-item" (click)="openModalEditUserDialog()">
            <span class="left-nav-account-item-main">
              <i class="fa-duotone fa-lg fa-user"></i>
              <span>Min profil</span>
            </span>
          </button>

          @if(portalUsers().length > 0 && !isTechnician() && !isAssembler() && !isAftermarket()) {
            <button type="button" class="left-nav-account-item is-expandable" (click)="toggleSellerMenu($event)">
              <span class="left-nav-account-item-main">
                <i class="fa-duotone fa-lg fa-swap"></i>
                <span>Byt säljare</span>
              </span>
              <i class="fa-duotone" [class.fa-angle-down]="isSellerMenuOpen()" [class.fa-angle-right]="!isSellerMenuOpen()"></i>
            </button>

            @if(isSellerMenuOpen()) {
              <div class="left-nav-account-submenu">
                @let uId = userContext()?.selectedUser?.USERID;
                @for(item of portalUsers(); track item.USERID) {
                  <button type="button" class="left-nav-account-subitem" [ngClass]="{'active' : uId === item.USERID }" (click)="setSelectedPortalUser(item)">
                    <span>
                      {{ item.USERFULLNAME }}
                      @if(uId === item.USERID) {
                        <i class="fa-duotone fa-star ms-2 text-warning float-end"></i>
                      }
                    </span>
                  </button>
                }
              </div>
            }
          }

          @if(allowRoleChange() && !isAftermarket()) {
            <button type="button" class="left-nav-account-item is-expandable" (click)="toggleRoleMenu($event)">
              <span class="left-nav-account-item-main">
                <i class="fa-duotone fa-lg fa-people-arrows"></i>
                <span>Byt roll</span>
                @if(loadingRoleChange()) {
                  <i class="fa-duotone fa-lg fa-spinner fa-pulse ms-2"></i>
                }
              </span>
              <i class="fa-duotone" [class.fa-angle-down]="isRoleMenuOpen()" [class.fa-angle-right]="!isRoleMenuOpen()"></i>
            </button>

            @if(isRoleMenuOpen()) {
              <div class="left-nav-account-submenu">
                @if(newRole()) {
                  <div class="left-nav-account-note">
                    Roll uppdaterad. Logga ut för att ändringen ska slå igenom.
                  </div>
                } @else {
                  <div class="left-nav-account-note text-danger">
                    Vid byte av roll måste du logga ut och in för att ändringen ska slå igenom.
                  </div>
                }

                @let userRoleName = userContext()?.selectedUser.PERMISSIONROLENAME;
                @for(item of portalPermissionRoles(); track item.ROLEID) {
                  <button type="button" class="left-nav-account-subitem" [ngClass]="{'active' : userRoleName === item.ROLENAME}" (click)="setPortalPermissionRoles(item.ROLENAME)">
                    <span class="fw-semibold">
                      {{ item.ROLENAME }}
                    @if(userRoleName === item.ROLENAME) {
                      <i class="fa-duotone fa-star ms-2 text-warning float-end"></i>
                    }
                    </span>
                    @if(item.DESCRIPTION) {
                      <small class="left-nav-account-description mt-2">{{ item.DESCRIPTION }}</small>
                    }
                  </button>
                }
              </div>
            }
          }

        </div>
      }
    </aside>
  </div>
}

<ng-template #editUserProfileTemplate>
  <user-setup [userToEditID]="''" [contactToConvertID]="'0'" [custAccountToConvert]="''" [modalId]="userProfileModalId">
  </user-setup>
</ng-template>

<ng-template #contactSupportTemplate>
  <contact-support [modalId]="contactSupportModalId"></contact-support>
</ng-template>

<ng-template #estimatedDeliveryWeeksTemplate>
  <estimated-delivery-weeks [modalId]="estimatedDeliveryWeeksModalId"></estimated-delivery-weeks>
</ng-template>

<ng-template #inventoryBalanceTemplate>
  <inventory-balance [modalId]="inventoryBalanceModalId"></inventory-balance>
</ng-template>
